import MoreCard from '@klv/molecules/more-card';
import Grid from '@klv/utils/grid';

import * as styles from './styles/more-cards.module.css';

import type { IMoreCards } from './types';

const MoreCards = ({ moreCards, headline }: IMoreCards) => (
  <Grid className={styles.container}>
    <div className={styles.headlineContainer}>
      {headline && (
        <h2 className={styles.headline}>
          {headline}
        </h2>
      )}
    </div>
    <div className={styles.cardsContainer}>
      {moreCards.map((card) => (
        <MoreCard
          key={card.eyebrow}
          {...card}
        />
      ))}
    </div>
  </Grid>
);

export default MoreCards;
